import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { proDriverDrawerQuery } from "@/app/ProDrivers/Drivers/GraphQL/proDriverDrawerQuery";
import { useNavigate, useSearch } from "@tanstack/react-router";

const FROM = "/$tenant/$orgId/supplier/{-$supplierId}";

export function useProDriverDrawer() {
  const search = useSearch({ from: FROM });

  if (!search.proDriverId) {
    throw new Error("Pro driver id is not present in the search params");
  }

  const { data } = useSuspenseGqlQuery(proDriverDrawerQuery, {
    id: search.proDriverId,
  });

  return data.proDriver;
}

export function useOpenProDriverDrawer() {
  const navigate = useNavigate();

  return (proDriverId: string) => {
    navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => ({ ...prev, proDriverId }),
    });
  };
}
